import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { GlobalService } from '../service/global.service';
import { AuthService } from '../services/accounts/auth.service';
import { RbacService } from '../services/accounts/rbac.service';
import { buildMenuList } from '../sidebar/menu-builder';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { CustomHttpService } from '../services/custom-http.service';
import { CurrencyService } from '../services/currency.service';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['../sidebar/sidebar.component.css', './header-mobile.component.css']
})
export class HeaderMobileComponent {
   @ViewChild('contentWrapper') contentWrapper!: ElementRef;

  companyName: string = '';
  isCustomBackground: boolean = false;
  user: any = {}
  company:any = {};
  isProfilePage: boolean = false;
  showDropdown: boolean = false;
  displayCurrency: string = 'KES';
  convertedBalance: number | null = null;
  private destroy$ = new Subject<void>();

    // State to track if the dropdown is expanded or collapsed
  isExpanded: boolean = false;
  // This will hold the actual height of the content for smooth transition
  contentHeight: string = '0px';

  // menuList:any=[  
  //   {'title':'Home','url':'/home','icon':'Icon.svg','menu_opened':false,'openedImage':'Home_select.png','showSubmenu':false},
  //   {'title':'Booking','url':'/booking','icon':'calender.png','menu_opened':true,'openedImage':'booking_select.png','showSubmenu':false},
  //   {'title':'My Trips','url':'/booking/trips','icon':'light.png','menu_opened':false,'openedImage':'airplane.svg','showSubmenu':false},
  //   {'title':'Approvals','url':'/booking/approvals','icon':'light.png','menu_opened':false,'openedImage':'airplane.svg','showSubmenu':false},
  //   {'title':'Company Profile','url':'/companyprofile','icon':'enterprise.png','menu_opened':false,'openedImage':'enterprise.png','showSubmenu':false},
  // ]

  menuList: any = buildMenuList(null);

  bottomMenuList: any = [
    {'title': 'Logout', 'url': '', 'icon': '../exit.png'},
  ];

  constructor (
    public global:GlobalService,
    public auth: AuthService,
    private rbac: RbacService,
    private router: Router,
    public customHTTP:CustomHttpService,
    private renderer: Renderer2,
    public currencyService: CurrencyService,
    public themeService: ThemeService
  ){
  }

  private recomputeBalance() {
    const d = this.currencyService.display(this.company?.account_balance);
    this.displayCurrency = d.currency;
    this.convertedBalance = d.amount;
  }

  /** Re-reads the decoded identity and re-fetches the balance off the current token.
   *  Called on init and again on every AuthService.identityChanged$ emission (login,
   *  or a silent refresh) — without this, a refreshed token never gets reflected here. */
  private loadIdentity() {
    this.user = this.auth.user();
    this.companyName = this.user.company_name;
    this.customHTTP.getBalance(this.auth.getUserCompanyId())
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (data) => { this.company = data; this.recomputeBalance() },
          error: (err) => console.error('Error fetching balance:', err)
        }
    )
  }

  ngOnInit() {
    this.loadIdentity();
    this.auth.identityChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadIdentity());

    this.rbac.rbac$.subscribe(me => {
      this.menuList = buildMenuList(me);
      this.highlightActiveMenu(this.router.url);
    });

    // Highlight active route after navigation ends
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const currentUrl = event.urlAfterRedirects;
        this.highlightActiveMenu(currentUrl);
      });
  }
  
    // Lifecycle hook called after Angular initializes the component's views and child views
  ngAfterViewInit() {
    // Height calculation removed in favor of robust CSS transitions
  }

  toggleCustomDropdown(): void {
    this.isExpanded = !this.isExpanded;
  }

  closeDrawer(): void {
    this.isExpanded = false;
  }
  highlightActiveMenu(currentUrl: string) {
    const normalizedUrl = this.normalizeUrl(currentUrl);
    this.menuList.forEach((item: { menu_opened: boolean; showSubmenu: boolean; url: string; submenu: any[]; }) => {
      item.menu_opened = false;
      item.showSubmenu = false;

      if (item.url && this.isActiveRoute(normalizedUrl, item.url)) {
        item.menu_opened = true;
      }

      if (item.submenu && item.submenu.length > 0) {
        item.submenu.forEach(sub => {
          sub.menu_opened = false;
          if (this.isActiveRoute(normalizedUrl, sub.url)) {
            sub.menu_opened = true;
            item.menu_opened = true;
            item.showSubmenu = true;
          }
        });
      }
    });
  }

  normalizeUrl(url: string): string {
    const path = (url || '').split('?')[0].split('#')[0];
    return path === '/' ? '/home' : path;
  }

  isActiveRoute(currentUrl: string, itemUrl: string): boolean {
    if (!itemUrl) {
      return false;
    }

    return currentUrl === itemUrl;
  }

  toggleSubmenu1(menuItem: any): void {
    const hasSubmenu = !!(menuItem.submenu && menuItem.submenu.length);
    const shouldOpen = hasSubmenu ? !menuItem.showSubmenu : true;

    this.menuList.forEach((otherItem: any) => {
      otherItem.menu_opened = false;
      otherItem.showSubmenu = false;
    });
    menuItem.showSubmenu = hasSubmenu && shouldOpen;
    menuItem.menu_opened = shouldOpen;
  }

  toggleSubMenu(item: any) {
    item.menu_opened = true;

    this.menuList.forEach((otherItem: any) => {
        if (otherItem.submenu && otherItem.submenu.length > 0) {
          otherItem.submenu.forEach((submenuItem : any) =>{
           if(submenuItem.title!= item.title){
             submenuItem.menu_opened=false;
           }
          })
      }
    });
  }

  navigateSubMenu(item: any): void {
    if (item.disabled) {
      return;
    }
    this.toggleSubMenu(item);
    if (item.url) {
      this.router.navigate([item.url]);
      this.closeDrawer();
    }
  }

  toggleMenu(item: any): void {
    if (item.disabled) {
      return;
    }
    this.toggleSubmenu1(item);
    if (item.url) {
      this.router.navigate([item.url]);
      this.closeDrawer();
    }
  }
    logout() {
    this.auth.logout()
  }

  toggleDropdown(){
    this.showDropdown = !this.showDropdown
  }

  navigateToUserProfile(){
    this.router.navigate(['/userprofile'])
  }

}
